<template>
  <section class="section is-size-7">
    <div class="container-fluid">
      <div class="card" v-if="!isPreview && !isEmailCaseLog">
       <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="card-header">Total Count: <strong>{{totalCount}}</strong>
        </div>
        <div class="rowFullTable" v-if="emailCasesArray.length">
          <table class="table table-fixed table-hover tableFixHeadBottom table-text-cente">
            <thead class="table-head">
              <th class="row-ID">CaseID</th>
              <th class="row-Desc">AssignTo</th>
              <th class="row-incident-level">EmailInfo</th>
              <th class="row-Date">Status</th>
              <th class="row-Date">Attachment</th>
              <th class="row-ID">Preview</th>
            </thead>
            <tbody class="position-relative">
              <tr v-for="(emailCase,index) in emailCasesArray">
                <td>
                    <!-- View Email Case Log Visibilty in Trackshipment summary -->
                  <button type="button" class="btn btn-link px-0" @click="showEmailCaseLog(emailCase.caseid)" title="View Email Case Log">{{emailCase.caseid}}</button>
                  <br><span
                    :class="{'tag is-warning':emailCase.isrepeatcount && emailCase.isrepeatcount.toLowerCase() === 'yes'}"
                    v-if="emailCase.isrepeatcount && emailCase.isrepeatcount.toLowerCase() === 'yes'">RepeatEmail</span>
                </td>
                <td>
                  <div class="media-body">
                    <b>Assigned To : </b>
                    <span class="text-muted">{{emailCase.assignedto}}</span><br>
                    <b>Created Date :</b>
                    <span class="text-muted">{{emailCase.createddate | dateFilter}}</span><br>
                    <b>Last Modified By : </b>
                    <span class="text-muted">{{emailCase.lastmodifiedby}}</span><br>
                    <b>Last Modified Date : </b>
                    <span class="text-muted">{{emailCase.lastmodifieddate | dateFilter}}</span>
                  </div>
                </td>
                <td>
                  <b>From:</b> <span class="text-muted">
                    {{emailCase.fromid}}
                  </span> <br>
                  <b>Subject:</b> <span>
                    <span class="text-muted"
                      v-if="emailCase.subject && emailCase.subject && emailCase.subject.length <=200">{{emailCase.subject}}</span>
                    <span class="text-muted" v-else-if="emailCase.subject && emailCase.subject">
                      <b-tooltip :label="emailCase.subject" multilined>
                        {{emailCase.subject.substring(0, 200)}} ...
                      </b-tooltip>
                    </span>
                  </span> <br>
                  <b>Originate Source:</b>
                  <span v-if="emailCase.originatesource">
                    <span class="text-muted"
                      v-if="emailCase.originatesource.toLowerCase() === 'cbfeedbackemail'">
                      CB
                    </span>
                    <span class="text-muted"
                      v-else-if="emailCase.originatesource.toLowerCase() === 'feedbackemail'">
                      Web
                    </span>
                    <span class="text-muted"
                      v-else-if="emailCase.originatesource.toLowerCase() === 'needhelp'">
                      Need Help
                    </span>
                  </span>
                  <span class="text-muted" v-else> CCEmail</span></td>
                <td>
                  <h6>
                    <span v-if="emailCase.status == 'allocationpending'" v-bind:class="[emailCase.status == 'allocationpending' ? 'badge badge-warning is-capitalized' : '' ]">{{emailCase.status}}</span>
                    <span v-if="emailCase.status == 'allocated'" v-bind:class="[emailCase.status == 'allocated' ? 'badge badge-danger is-capitalized' : '' ]">{{emailCase.status}}</span>
                    <span v-if="emailCase.status == 'inprocess'" v-bind:class="[emailCase.status == 'inprocess' ? 'badge badge-info is-capitalized' : '' ]">{{emailCase.status}}</span>
                    <span v-if="emailCase.status == 'Close'" v-bind:class="[emailCase.status == 'Close' ? 'badge badge-success is-capitalized' : '' ]">{{emailCase.status}}</span>
                    <span v-if="emailCase.status == 'spam'" v-bind:class="[emailCase.status == 'spam' ? 'badge badge-secondary is-capitalized' : '' ]">{{emailCase.status}}</span>
                    <span v-if="emailCase.status == 'trash'" v-bind:class="[emailCase.status == 'trash' ? 'badge badge-dark is-capitalized' : '' ]">{{emailCase.status}}</span>
                    <span v-if="emailCase.status == 'followup'" v-bind:class="[emailCase.status == 'followup' ? 'badge badge-info is-capitalized' : '' ]">{{emailCase.status}}</span>
                </h6>
                </td>
                <td>
                  <span
                    v-if="emailCase && emailCase.isattachment && emailCase.isattachment.toLowerCase() ==='yes'">
                    <router-link
                      :to="{ path: encodeURI('/emailattachment'), query: {inboxID : emailCase.inboxid, caseID:emailCase.caseid} }"
                      id="link" title="View Attachment" target="_blank">
                      <a>
                        <button variant="outline-primary">
                          <i class="fa fa-paperclip"></i>
                        </button>
                      </a>
                    </router-link>
                  </span>
                  <span v-else>
                    No
                  </span>
                </td>
                <td><p>
                <!-- <td><p v-if="emailCase.status.toLowerCase()==='inprocess' || emailCase.status.toLowerCase()==='close'"> -->
                      <b-button variant="outline-primary btn-sm" @click="getEmailPreview(emailCase.caseid);isPreview=true" title="Email Preview"><i class="fa fa-eye"></i></b-button>
                    </p>
                </td>

              </tr>
              <tr v-if="emailCasesArray.length==0">
                <td colspan="7" align="center">Records not found</td>
              </tr>
            </tbody>
          </table>
            <div>
              <paginate v-if="totalPages>1" :page-count="totalPages" :margin-pages="3" :click-handler="getPaginationData"
                ref="paginate" :prev-text="'⏮'" :next-text="'⏭'" :container-class="'pagination'"
                :page-class="'page-item'" :pageLinkClass="'page-link-item'">
              </paginate>
          </div>
        </div>
      </div>
       <div class="card" v-if="isPreview && !isEmailCaseLog">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
         <b-button @click="isPreview=false" variant="link">Back</b-button>
          <b-table sticky-header class="table-outline mb-0" hover striped responsive="sm" outline
              :fields="emailPreviewFields"
              :items="emailMessageArray"
              head-variant="default"
              v-model="currentItems">
            <template slot="show_details" scope="{ detailsShowing, item }" >
              <!-- Use the built in method from the scoped data to toggle the row details -->
              <b-btn @click="toggleDetails(item)">{{ detailsShowing ? 'Hide' : 'Show'}}</b-btn>
            </template>
            <template slot="row-details" scope="{ item }">
              <div class="card-body">
                <div class="row mb-4">
                  <div class="col-sm-4">
                    <div>
                      <b>Email From :</b>
                      {{item.fromid}}
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-sm-4">
                    <div>
                      <b>Email To :</b>
                      {{item.toid}}
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-sm-4">
                    <div>
                      <b>Email CC :</b>
                      {{item.cc}}
                    </div>
                  </div>
                </div>
                 <div class="row mb-4">
                  <div class="col-sm-4">
                    <b>Email Subject :</b>
                    <span v-html="item.subject"></span>
                  </div>
                </div>
                <div class="row mb-8">
                  <div class="col-sm-8">
                      <b>Email Body :</b>
                      <span class="test" v-html="item.emailbody"></span>
                  </div>
                </div>
              </div>
            </template>
             <!-- A custom formatted column -->
            <template slot="emaildate" scope="item" >
              <span>{{ item.value | formatDate }}</span>
            </template>
             <!-- A custom formatted column -->
            <template slot="emailtype" scope="item" >
              <span v-if="item.value.toLowerCase() == 'in'">Received</span>
              <span v-if="item.value.toLowerCase() == 'out'">Sent</span>
            </template>

            <!-- A custom formatted column -->
            <template slot="isattachment" scope="item" >
              <span>
                <span v-if="item.item.emailtype === 'in' && item.value && item.value && item.value.toLowerCase() ==='yes'">
                  <router-link :to="{ path: encodeURI('/emailattachment'), query: {inboxID : item.item.inboxid, caseID:item.item.caseid} }"  id="link" title="View Attachment" target="_blank"><a>View Attachment</a></router-link>
                </span>
                <span v-if="item.item.emailtype === 'out' && item.value && item.value && item.value.toLowerCase() ==='yes'">
                  <router-link :to="{ path: encodeURI('/emailattachment'), query: {outboxID : item.item.id, caseID:item.item.caseid} }"  id="link" title="View Attachment" target="_blank"><a>View Attachment</a></router-link>
                </span>
                <span v-else>
                    no
                </span>
              </span>
            </template>
          </b-table>
      </div>
    <!-- View Email Case Log Visibilty in Trackshipment summary -->
      <div class="card" v-if="isEmailCaseLog && !isPreview">
       <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <b-button @click="isEmailCaseLog=false" variant="link">Back</b-button>
        <div class="rowFullTable" v-if="emailCaseLog && emailCaseLog.length">
          <table class="table-outline mb-0 table table-fixed table-hover tableFixHeadBottom table-text-cente" style="width: 100%;" sticky-header hover striped responsive="sm" outline>
            <thead class="table-head" head-variant="default">
              <th style="width: 10%">Case ID</th>
              <th style="width: 13%">Allocation Type</th>
              <th style="width: 20%">Created By</th>
              <th style="width: 15%">Created Date</th>
              <th style="width: 15%">Email Status</th>
              <th style="width: 30%">Comment</th>
            </thead>
            <tbody class="position-relative">
              <tr v-for="(emailCase,index) in emailCaseLog">
                <td><span>{{emailCase.caseid}}</span></td>
                <td><span>{{emailCase.allocationtype || '-'}}</span></td>
                <td><span>{{emailCase.createdby}}</span></td>
                <td><span>{{emailCase.createddate | dateFilter}}</span></td>
                <td><span>{{emailCase.status}}</span></td>
                <td><span>{{emailCase.comment}}</span></td>
              </tr>
              <tr v-if="!emailCaseLog || emailCaseLog.length==0">
                <td colspan="7" align="center">Records not found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import Vue from 'vue'
  import VeeValidate from 'vee-validate'
  import { VueEditor, Quill } from "vue2-editor";
  import filters from '@/filters/filter'
  import apiUrl from '../../../constants'
  import axios from 'axios'
  import moment from 'moment'
  import commonFunction from '../../../commonFunction'
  import constantVariable from '../../../constantVariable'
  import Paginate from 'vuejs-paginate'
  import DatePicker from 'vue2-datepicker';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import {
    BasicSelect
  } from 'vue-search-select';
  import CryptoJS from 'crypto-js';

  const config = {
    errorBagName: 'errors', // change if property conflicts.
    fieldsBagName: 'fields',
    delay: 0,
    locale: 'en',
    dictionary: null,
    strict: true,
    enableAutoClasses: false,
    classNames: {
      touched: 'touched', // the control has been blurred
      untouched: 'untouched', // the control hasn't been blurred
      valid: 'valid', // model is valid
      invalid: 'invalid', // model is invalid
      pristine: 'pristine', // control has not been interacted with
      dirty: 'dirty' // control has been interacted with
    },
    events: 'input|blur',
    inject: true
  };
  Vue.use(VeeValidate,config);
  //Vue.use(Buefy);

  export default {
    name: 'trackingemailtracking',
    filters: {
      //dateFilter: filters.formatDate
    },
    components: {
      Loading,
      Paginate,
      DatePicker,
      BasicSelect,
      VueEditor
    },
    data: () => ({
      image: null,
      data:"",
      tabIndex: 0,
      reallocate: {
        agent: '',
        allocationreasoinid: '',
        comment: ''
      },
      pageName: 'emailr',
      isLoading: false,
      emailCasesArray: [],
      page: 0,
      noOfPages: 1,
      totalPages: 0,
      pageSize: 10,
      pageItemList: [10, 20, 30],
      isSearch: false,
      fromemail: '',
      toemail: '',
      emailsubject: '',
      emailmessage: '',
      recipientid: '',
      carboncopy: '',
      agentDisabled: true,
      showReAllocationForm: false,
      showArtical: true,
      previetickid: '',
      loggedUser: {
        role: ''
      },
      hoverable: true,
      allocateCount: 0,
      inprocessCount: 0,
      totalCount: 0,
      isSearchModal: true,
      emailMessageArray: [],
      viewBody: '',
      teamLeads: [],
      teamLeadEmail: '',
      designation: '',
      userDetails: {},
      subDepartmentList: [],
      activeAgents: [],
      tlEmailId: '',
      tlemailid: '',
      tlMaster: [],
      showDetails: false,
      sourcename: 'ccemail', // this.userDetails.subdepartment[0].subdeptname
      sourceid: 5,
      selectedTab: 0,
      selectedCaseID: '',
      activeComponent: 'Case List',
      userRole: '',
      username: '',
      userid: '',
      emailCaseLog: [],
      isLoadingPagination: false,
      fullPage: false,
      pageno: 0,
      pagecount: 0,
      perpage: 10,
      selectedCaseIds: [],
      isPreview: false,
      isEmailCaseLog: false,
      emailMessageArray: [],
      isActiveLogModal: false,
      ticketid: '',
      emailcaseID: '',
      defaultSortDirection: 'desc',
      defaultOpenedDetails: [],
      currentItems: [],
      emailPreviewFields: {
        caseid: {
          key: 'caseid',
          label: 'Case ID',
          class: 'row-ID'
        },
        fromid: {
          key: 'fromid',
          label: 'Email From',
          class: 'row-Desc'
        },
        emaildate: {
          key: 'emaildate',
          label: 'Email Date',
          class: 'row-incident-level'
        },
        emailtype: {
          key: 'emailtype',
          label: 'Email Type',
          class: ' row-Date'
        },
        subject: {
          key: 'subject',
          label: 'Subject',
          class: 'row-ID'
        },
        isattachment: {
          key: 'isattachment',
          label: 'Attachment'
        },
        lastmodifiedby: {
          key: 'lastmodifiedby',
          label: 'Last Modified By'
        },
        show_details:{
          key: 'show_details',
          label: '',
          _style: { width: '1%' },
          sorter: false,
          filter: false
        }
      },
      emailPreviewModal : false,
      isModalLoading : false,
      fullPage: false
    }),
    props: ['setShippingID', 'setEmailCases', 'setTotalCount'],
    created() {

       this.shippingId = this.setShippingID;
       this.emailCasesArray = this.setEmailCases;
      //  console.log( 'shippingId : '+this.shippingId );
    },
    watch: {

      setShippingID: function (o, n) {
        this.shippingId = this.setShippingID
      },
      setEmailCases: function (o, n) {
        this.emailCasesArray = this.setEmailCases
      },
      setTotalCount: function (o, n) {
        this.totalCount = this.setTotalCount
      }
    },
    mounted() {
      //  console.log( 'shippingId : '+this.shippingId );
    },
    methods: {

      loadMore: function () {
        this.page++
        this.getEmailCases()
      },

      loadPrev: function () {
        this.page--
        this.getEmailCases()
      },

      changePageSize: function () {
        this.page = 0
        this.getEmailCases()
      },

      getTotalPages: function (result) {
        let total = parseInt(result / this.pageSize)
        let remainder = result % this.pageSize
        if (remainder > 0) {
          this.totalPages = total + 1
        } else {
          this.totalPages = total
        }
      },

      getDetailLevel: function (data, index ) {
        this.currentCaseId = '';
        // console.log('data : ' + JSON.stringify( data ) );
        let getObj = {
          caseid: data.caseid
        }
        Object.keys(getObj).forEach((key) => {
          if (getObj[key] === '' || getObj[key] === null || getObj[key] === undefined) {
            delete getObj[key]
          }
        })
        // console.log('getObj : ' + JSON.stringify( getObj ));

        this.showDetails = false;
        return axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'ticketdetails',
            headers: commonFunction.getusertoken(),
            'data': getObj
          })
          .then((result) => {

            this.isSearchModal = false;
            this.isSearchTicket = false;
            if (result.data.data.data.length) {
              this.emailCasesArray[this.emailCasesArray.indexOf(data)].allTickets = result.data.data.data;
              this.currentCaseId  = index;
            }

            this.showDetails = true;
          })
          .catch((httpException) => {
            this.showDetails = true;
            // console.log('Error In ticketdetailso', httpException)
          })
      },
       toggleDetails(item) {
      // console.log( 'item : '+JSON.stringify( item ) );
      if(item._showDetails){
        this.$set(item, '_showDetails', false)
      }else{
        this.currentItems.forEach(item => {
          this.$set(item, '_showDetails', false)
        })

        this.$nextTick(() => {
          this.$set(item, '_showDetails', true)
        })
      }
    },
    /**
     * [On click of ticketid from ticket details tab email preview api called.]
     * @return {[type]} [getEmailPreview]
     */
    getEmailPreview: function (emailcaseID) {
      this.fromemail = ''
      this.toemail = ''
      this.emailsubject = ''
      this.emailmessage = ''
      this.recipientid = ''
      this.carboncopy = ''
      this.previetickid = ''
      let emailPreviewTicketDetails = {
        ticketid: '',
        caseid: [emailcaseID]
      }
      this.isLoading = true
      this.emailMessageArray = []

      return axios({
        'method': 'POST',
        'url': apiUrl.api_url + 'getemaildetails',
        headers: commonFunction.getusertoken(),
        'data': emailPreviewTicketDetails
      }).then((result) => {
          // console.log( 'result  getEmailPreview : '+JSON.stringify( result ) );
         // console.log( 'outbox : '+result.outbox );
          //console.log( 'outbox stringify : '+JSON.stringify( result.outbox ) );
          this.isLoading = false
          let emails = []
          if (result.data) {
            if (result.data) {
              if (result.data) {
                if( result.data.outbox != undefined && result.data.outbox.length > 0 ) {
                  // console.log( 'outbox record' );
                  result.data.outbox.forEach((outbox) => {
                      if (outbox) {
                        let base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
                        let isEncoded = (outbox.emailbody && outbox.emailbody) ? base64regex.test(outbox.emailbody.toString()) : ''
                        if (isEncoded) { // If string is encoded in base64 format then decode string
                          outbox.emailbody = Buffer.from(outbox.emailbody, 'base64').toString()
                        }
                        emails.push({
                          emailbody: (outbox.emailbody && outbox.emailbody) ? outbox.emailbody : '',
                          caseid: outbox.caseid,
                          emailtype: (outbox.emailtype) ? outbox.emailtype : '',
                          emaildate: (outbox.createddate) ? outbox.createddate : '',
                          subject: (outbox.subject) ? outbox.subject : '',
                          isattachment: (outbox && outbox.isattachment) ? outbox.isattachment : '',
                          inboxid: (outbox.inboxid) ? outbox.inboxid : '',
                          id: (outbox.id) ? outbox.id : '',
                          lastmodifiedby: outbox.createdby,
                          fromid: apiUrl.EMAILR_CONFIG_DATA[0].EMAILR_ACK_EMAIL.trim().toLowerCase(),
                          cc: outbox.cc ? outbox.cc : '',
                          toid: outbox.toid ? outbox.toid : ''
                        })
                      }
                  })
                }
              }
              result.data.inbox.forEach((inbox) => {
                  let base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
                  let isEncoded = (inbox.emailbody && inbox.emailbody) ? base64regex.test(inbox.emailbody.toString()) : ''
                  if (isEncoded) { // If string is encoded in base64 format then decode string
                    inbox.emailbody = Buffer.from(inbox.emailbody, 'base64').toString()
                  }

                  emails.push({
                    emailbody: (inbox && inbox.emailbody && inbox.emailbody) ? inbox.emailbody : '',
                    caseid: inbox.caseid,
                    emailtype:  (inbox.emailtype) ? inbox.emailtype : '',
                    emaildate: (inbox && inbox.createddate) ? inbox.createddate : '',
                    subject: (inbox && inbox.subject) ? inbox.subject : '',
                    isattachment: (inbox && inbox.isattachment) ? inbox.isattachment : '',
                    inboxid: (inbox && inbox.inboxid) ? inbox.inboxid : '',
                    lastmodifiedby: inbox.lastmodifiedby || '',
                    fromid: (inbox && inbox.fromid) ? inbox.fromid : '',
                    toid: inbox.toid ? inbox.toid : '',
                    cc: inbox.cc ? inbox.cc : ''
                  })
                  //console.log( 'inbox : '+JSON.stringify( inbox ) );
                  //console.log( 'emails : '+ JSON.stringify( emails ) );
              })
            }
            // console.log( 'Emails : '+emails.length );

            if (emails.length) {
              emails.forEach((b) => {
                if (!this.isHTML(b.emailbody)) {
                  b.emailbody = '<pre>' + b.emailbody + '</pre>'
                }
              })
              this.defaultOpenedDetails.push(emails[emails.length - 1])
              emails.sort(function(fDate, sDate) {
                  if (sDate.emaildate && fDate.emaildate) {
                    return new Date(sDate.emaildate)-new Date(fDate.emaildate); // Will sort emaildate desc
                  }
              });
              this.emailMessageArray = emails
            }
          }
          // console.log( 'emailMessageArray Data : '+JSON.stringify( this.emailMessageArray ) );

        }).then(() => {
          // console.log( 'then ' );
          this.isActiveLogModal = true;
          // console.log( 'isActiveLogModal :  '+this.isActiveLogModal );
        })
        .catch((httpException) => {
          this.isLoading = false
          return this.$alertify.error(httpException.message);
        })
    },
    isHTML (str) {
      var doc = new DOMParser().parseFromString(str, 'text/html')
      return Array.from(doc.body.childNodes).some(node => node.nodeType === 1)
    },
    getDetailsLevel: function (data) {
      this.emailPreviewModal = true;
      this.defaultOpenedDetails = [data]
    },
    closePreviewModal: function () {
      this.defaultOpenedDetails = []
       this.isPreview = false;
    },
    expandAdditionalInfo(item) {
      item._showDetails = !item._showDetails;
    },
  // View Email Case Log Visibilty in Trackshipment summary 
    getEmailCaseLog: function (emailCaseID) {
      let object = {
        caseid: [emailCaseID]
      }
      this.isLoading = true;
      this.emailCaseLog = [];
      
      return axios({
        'method': 'POST',
        'url': apiUrl.api_url + 'getemailcaselog',
        headers: commonFunction.getusertoken(),
        'data': object
      }).then((result) => {
        this.isLoading = false;
        if (result && result.data && result.data.length) {
          this.emailCaseLog = result.data;
        } else {
          this.$alertify.warning("No email case log data found");
        }
      }).catch((httpException) => {
        this.isLoading = false;
        this.$alertify.error(httpException.message || "Failed to load email case log");
      })
    },
    
    closeEmailCaseLog: function() {
      this.isEmailCaseLog = false;
      this.emailCaseLog = [];
    },
    
    showEmailCaseLog: function(caseId) {
      this.isPreview = false;
      this.getEmailCaseLog(caseId);
      this.isEmailCaseLog = true;
    }
    }
}
</script>
<style lang="css" scoped>
  .previewModal {
    width: 85% !important;
  }
  .compRedCss {
    color: red !important;
  }
  div.mce-edit-area {
    background: #FFF;
    filter: none;
    height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/components/emailr/trackingemailtracking.vue?6797b238